import HeroSection from '../components/HeroSection';
import HowItWorks from '../components/HowItWorks';
import Benefits from '../components/Benefits';
import PricingCards from '../components/PricingCards';
import CTASection from '../components/CTASection';

export const HomePage = () => {
  return (
    <main data-testid="home-page">
      <HeroSection />
      <HowItWorks />
      <Benefits />
      <PricingCards />
      <CTASection />
    </main>
  );
};

export default HomePage;
